import NoPlayerFilter from "./NoPlayerFilter";
import NoPlayerItem from "./NoPlayerItem";

const NoPlayer = () => {
  return (
    <>
      <NoPlayerFilter />
      <NoPlayerItem/>
    </>
  );
};

export default NoPlayer;
